import React, { useEffect, useRef, useState } from "react";

import {
    Container,
    Row,
    Col,
    Card,
    Button,
    ToggleButton,
    ToggleButtonGroup,
    Badge,
    Modal
} from "react-bootstrap";

import {
    CheckCircleFill
} from "react-bootstrap-icons";

import "../../assets/css/upgradeplan.scss";

import AppNavbar from "../Navbar/AppNavbar";
import Footer from "../Navbar/Footer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import AddCreditsCard from "./AddCreditsCard";
import { capitalizeFirstLetter } from "../CommonFile/Function_utils";
import { monthlyPlans, yearlyPlans } from "../CommonFile/DropdownValues";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import * as HeaderAuthentication from '../HeaderAuthentication';
import { loadCreditsData, loadUpgradePlan } from "../redux/action";

function UpgradePlan() {
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const { getCredits } = useSelector(state => state.data);

    const dispatch = useDispatch();

    const [billingType, setBillingType] = useState("monthly");
    const [selectedPlan, setSelectedPlan] = useState("");
    const [selectPlanData, setSelectPlanData] = useState();
    const [selectedAddCredits, setSelectedAddCredits] = useState({});

    const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState(null);

    const hasRun = useRef(false);

    // region calling page load function
    useEffect(() => {
        if (Object.keys(getCredits).length !== 0) {
            if (hasRun.current) return;
            hasRun.current = true;

            setSelectedPlan(getCredits?.current_plan)
            let currentType = []
            if (getCredits?.plan_type === "Monthly") {
                currentType = monthlyPlans
            } else if (getCredits?.plan_type === "Yearly") {
                currentType = yearlyPlans
            }

            if (currentType.length > 0) {
                console.log(currentType, "currentType")
                currentType.forEach(item => {
                    if (item.name.toLowerCase() === getCredits?.current_plan.toLowerCase()) {
                        setSelectPlanData(item)
                        selectedPlanDetail(billingType, item, selectedAddCredits);
                    }
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCredits, monthlyPlans, yearlyPlans])
    // endregion

    // region plan selection beased on billing type
    const plans =
        billingType === "yearly"
            ? yearlyPlans
            : monthlyPlans;
    // endregion

    // region function to select plan
    const selectPlanFun = (plan) => {
        setSelectPlanData(plan)
        setSelectedPlan(plan.name)
        selectedPlanDetail(billingType, plan, selectedAddCredits);
    }
    // endregion

    // fucntion for settting summary values
    const [planAmnt, setPlanAmnt] = useState(0);
    const [addAmnt, setAddAmnt] = useState(0);
    const [totalAmnt, setTotalAmnt] = useState(0);

    const selectedPlanDetail = (billingType, plan, selectedAddCredits) => {
        let total_amnt = 0;

        // console.log(billingType, "billingType");
        if (Object.keys(plan).length > 0) {
            console.log(plan, "selectPlanData");
            let plan_amnt = 0;
            if (billingType === "monthly") {
                plan_amnt = parseInt(plan?.price.replace(/[^0-9]/g, ""));
            } else {
                plan_amnt = parseInt(plan?.price.replace(/[^0-9]/g, "")) * 12;
            }
            setPlanAmnt(plan_amnt);
            total_amnt = total_amnt + plan_amnt
        }
        if (Object.keys(selectedAddCredits).length > 0) {
            console.log(selectedAddCredits, "selectedAddCredits");
            setAddAmnt(selectedAddCredits?.cost)
            total_amnt = total_amnt + parseInt(selectedAddCredits?.cost.replace(/[^0-9]/g, ""))
        }
        setTotalAmnt(total_amnt);
    }
    // endregion

    // region function for selecting billing type
    const selectBillingType = (val) => {
        setBillingType(val);
        let currentType = []
        if (val === "monthly") {
            currentType = monthlyPlans
        } else if (val === "yearly") {
            currentType = yearlyPlans
        }

        if (currentType.length > 0) {
            currentType.forEach(item => {
                if (item.name.toLowerCase() === selectedPlan.toLowerCase()) {
                    setSelectPlanData(item)
                    selectedPlanDetail(val, item, selectedAddCredits);
                }
            })
        }
    }
    // endregion

    // region function for upgrade button

    const [showPaypal, setShowPaypal] = useState(false);
    const [paymentData, setPaymentData] = useState(null);

    const upgadrePlan = () => {
        const today = new Date();

        const start_date = today.toISOString().split("T")[0];
        const endDate = new Date(today);

        if (billingType?.toLowerCase() === "monthly") {
            endDate.setDate(endDate.getDate() + 30);
        } else if (billingType?.toLowerCase() === "yearly") {
            endDate.setDate(endDate.getDate() + 365);
        }

        const end_date = endDate.toISOString().split("T")[0];
        let addition_credit = 0
        if (Object.keys(selectedAddCredits).length > 0) {
            addition_credit = parseInt(selectedAddCredits?.credits)
        }
        console.log(selectedAddCredits, "selectedAddCredits")
        const total_credits = parseInt(selectPlanData?.credits.replace(/[^0-9]/g, "")) + addition_credit
        const payment_data = {
            payer_name: signInDetails[0].name,
            payer_id: signInDetails[0].id,
            payer_sbn: signInDetails[0].sbn_id,
            payer_email: signInDetails[0].email,
            payer_role: signInDetails[0].role,
            selected_plan: selectedPlan,
            billingType: billingType,
            plan_amount: planAmnt,
            add_amount: addAmnt,
            plan_credit: selectPlanData?.credits.replace(/[^0-9]/g, ""),
            add_credit: addition_credit,
            total_amount: totalAmnt,
            total_credits: total_credits.toString(),
            purchased_date: start_date,
            plan_expire_date: end_date
        }

        console.log(payment_data, "payment_data")

        setPaymentData(payment_data);

        // Show PayPal Buttons
        setShowPaypal(true);
    }
    // endregion

    return (
        <PayPalScriptProvider
            options={{
                // "client-id": "ATNG0OUjTeu_NatDrm8MzHHIHbyzOebHX3lnSAq09aiJudmYOOKBxdcMaRU2laY0wS2q3cP0cDk4m4N1",
                // "client-id": "ARb5E6IT369BdDbJOYbjtz-Lt_R7TwHVBZ90TQrtSoeVcGekapVnkD4afaSL2w9GJvAmCfK68edGMRuA", // Sand box
                // "client-id": "AV81RTlSOAK2qZBi6YwT327HULQnCiqN71eReKn2ocpdh2nxRDe7Jc0DYwzlp6bcFqR3rXVSWQVjWhFg", // Sand box
                "client-id": "AZJ9lrdiy3QXYaUzE_B1ta7qG0-WIZ1nW4P8FLP2r5S7jgNKK-5DBuEoF8raEsA5pPLiPIigZNlJfDdq", //live
                currency: "USD",
                intent: "capture",
            }}
        >
            <div className='page-layout'>

                <AppNavbar />
                <div
                    className='page-content'
                    style={{ overflow: "auto" }}>
                    <div className="upgrade-wrapper">
                        <Container fluid>

                            {/* payload modal */}
                            {showPaypal && paymentData && (
                                <div className="paypal-modal-overlay">

                                    <div className="paypal-modal">

                                        {/* Close */}
                                        <button
                                            className="paypal-close"
                                            onClick={() => setShowPaypal(false)}
                                        >
                                            ✕
                                        </button>

                                        <h2 className="paypal-title">
                                            Upgrade Plan
                                        </h2>

                                        <div className="payment-summary">

                                            <div className="summary-row">
                                                <span>Plan</span>
                                                <span>{paymentData.selected_plan}</span>
                                            </div>

                                            <div className="summary-row">
                                                <span>Billing</span>
                                                <span>{paymentData.billingType}</span>
                                            </div>

                                            <div className="summary-row">
                                                <span>Total Credits</span>
                                                <span>
                                                    {paymentData.total_credits}
                                                </span>
                                            </div>

                                            <div className="summary-row total">
                                                <span>Total Amount</span>
                                                <span>
                                                    ${paymentData.total_amount}
                                                </span>
                                            </div>

                                        </div>

                                        <div className="paypal-button-wrapper">

                                            <PayPalButtons

                                                style={{
                                                    layout: "vertical",
                                                    shape: "rect",
                                                    label: "paypal",
                                                }}

                                                createOrder={(data, actions) => {

                                                    return actions.order.create({

                                                        intent: "CAPTURE",

                                                        purchase_units: [
                                                            {
                                                                description:
                                                                    `${paymentData.selected_plan} Plan`,

                                                                amount: {
                                                                    currency_code: "USD",

                                                                    // IMPORTANT
                                                                    value:
                                                                        paymentData.total_amount.toString(),
                                                                },
                                                            },
                                                        ],
                                                    });
                                                }}

                                                onApprove={(data, actions) => {

                                                    return actions.order.capture()

                                                        .then(async (details) => {

                                                            console.log(
                                                                "PAYMENT SUCCESS",
                                                                details
                                                            );

                                                            console.log(details, "payment data")

                                                            const payment_dateils = []
                                                            const payment_address = []
                                                            let paymentUnits = details?.purchase_units
                                                            let payment_date = "";
                                                            let addition_credit = 0
                                                            if (Object.keys(selectedAddCredits).length > 0) {
                                                                addition_credit = parseInt(selectedAddCredits?.credits)
                                                            }
                                                            const total_credits = parseInt(selectPlanData?.credits.replace(/[^0-9]/g, "")) + addition_credit

                                                            const purchase = details.purchase_units[0];
                                                            const capture = purchase.payments.captures[0];

                                                            const paymentDate = new Date(capture.create_time);
                                                            const endDate = new Date(paymentDate);

                                                            if (billingType?.toLowerCase() === "monthly") {
                                                                endDate.setDate(endDate.getDate() + 30);
                                                            } else {
                                                                // Yearly
                                                                endDate.setDate(endDate.getDate() + 365);
                                                            }

                                                            setPaymentInfo({
                                                                customerName: signInDetails[0].name,
                                                                customerEmail: signInDetails[0].email,
                                                                sbnId: signInDetails[0].sbn_id,

                                                                payerEmail: details.payer.email_address,
                                                                payerId: details.payer.payer_id,

                                                                orderId: details.id,
                                                                captureId: capture.id,

                                                                amount: capture.amount.value,
                                                                currency: capture.amount.currency_code,

                                                                paymentDate,
                                                                planEndDate: endDate,

                                                                status: capture.status,

                                                                plan: selectedPlan,
                                                                billingType,
                                                                credits: total_credits,

                                                                merchantEmail: purchase.payee.email_address,
                                                                merchantId: purchase.payee.merchant_id
                                                            });


                                                            if (paymentUnits.length !== 0) {
                                                                paymentUnits.forEach((pay, i) => {
                                                                    if (pay?.payments?.captures.length !== 0) {
                                                                        pay?.payments?.captures.forEach((cap, i) => {
                                                                            payment_dateils.push({
                                                                                name: pay?.shipping?.name?.full_name,
                                                                                value: parseFloat(cap?.amount.value),
                                                                                currency_code: cap?.amount.currency_code,
                                                                                payment_date: cap?.create_time,
                                                                                quantity: parseInt(total_credits)
                                                                            })

                                                                            payment_date = cap?.create_time
                                                                        })
                                                                    }
                                                                })

                                                                payment_address.push({
                                                                    address_line_1: paymentUnits[0]?.shipping?.address?.address_line_1,
                                                                    admin_area_1: paymentUnits[0]?.shipping?.address?.admin_area_1,
                                                                    admin_area_2: paymentUnits[0]?.shipping?.address?.admin_area_2,
                                                                    country_code: paymentUnits[0]?.shipping?.address?.country_code,
                                                                    postal_code: paymentUnits[0]?.shipping?.address?.postal_code
                                                                })
                                                            }


                                                            const postPayment = {
                                                                customername: signInDetails[0].name,
                                                                customer_email: signInDetails[0].email,
                                                                sbn_id: signInDetails[0].sbn_id,
                                                                user_id: parseInt(signInDetails[0].id),
                                                                plan: selectedPlan,
                                                                billingType: billingType,
                                                                add_credits: parseInt(addition_credit),
                                                                payment_received_date_time: payment_date,
                                                                payer_email: details?.payer?.email_address,
                                                                order_id: details.id,
                                                                transaction_id: capture.id,
                                                                purchase_details: payment_dateils,
                                                                payment_address: payment_address,
                                                            }

                                                            let requestOption = {
                                                                method: "POST",
                                                                mode: "cors",
                                                                headers: HeaderAuthentication.postAuthOfLeadMerge,
                                                                body: JSON.stringify(postPayment),
                                                            };

                                                            dispatch(loadUpgradePlan(requestOption)).then(
                                                                (resp) => {
                                                                    console.log(resp, "payment")
                                                                    dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id));
                                                                }
                                                            ).catch((err) => { console.log(err) });


                                                            // alert("Payment Successful");
                                                            setShowPaypal(false);
                                                            setShowPaymentSuccess(true);
                                                        })

                                                        .catch((err) => {

                                                            console.log(
                                                                "CAPTURE ERROR",
                                                                err
                                                            );

                                                            // IMPORTANT FIX
                                                            if (
                                                                err?.details?.[0]?.issue ===
                                                                "INSTRUMENT_DECLINED"
                                                            ) {

                                                                return actions.restart();
                                                            }

                                                            alert("Payment Failed");
                                                        });
                                                }}

                                                onError={(err) => {

                                                    console.log(
                                                        "PAYPAL ERROR",
                                                        err
                                                    );

                                                    alert(
                                                        "Something went wrong with PayPal"
                                                    );
                                                }}

                                                onCancel={() => {

                                                    console.log(
                                                        "PAYMENT CANCELLED"
                                                    );

                                                    setTimeout(() => {
                                                        setShowPaypal(false);
                                                    }, 300);
                                                }}
                                            />

                                        </div>

                                    </div>

                                </div>
                            )}
                            {/* payload modal */}

                            <div className="upgrade-card-wrapper">
                                <div className="upgrade-header">
                                    <h1 className="main-title">
                                        Upgrade Your Plan
                                    </h1>
                                    <p className="sub-title">
                                        Choose a subscription or add extra credits anytime.
                                    </p>
                                    <div className="current-plan-box">
                                        <div className="current-plan-item">
                                            <span className="label">
                                                Current Plan
                                            </span>
                                            <h5>
                                                {capitalizeFirstLetter(getCredits?.current_plan)} Plan
                                            </h5>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="current-plan-item">
                                            <span className="label">
                                                Available Credits
                                            </span>
                                            <h4>
                                                {getCredits?.credits_aval}
                                            </h4>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="current-plan-item">
                                            <span className="label">
                                                Renewal Date
                                            </span>
                                            <h5>
                                                {getCredits?.end_date
                                                    ? moment(getCredits?.end_date).format("DD MMM YYYY")
                                                    : "-"}
                                            </h5>
                                        </div>
                                    </div>
                                </div>

                                {/* TOGGLE */}

                                <div className="billing-toggle">

                                    <ToggleButtonGroup
                                        type="radio"
                                        name="billing"
                                        value={billingType}
                                        onChange={(val) => selectBillingType(val)}
                                    >
                                        <ToggleButton
                                            id="monthly"
                                            value="monthly"
                                            variant={
                                                billingType === "monthly"
                                                    ? "primary"
                                                    : "light"
                                            }
                                        >
                                            Monthly
                                        </ToggleButton>

                                        <ToggleButton
                                            id="yearly"
                                            value="yearly"
                                            variant={
                                                billingType === "yearly"
                                                    ? "success"
                                                    : "light"
                                            }
                                        >
                                            Yearly
                                        </ToggleButton>

                                    </ToggleButtonGroup>

                                </div>

                                {/* SUBSCRIPTION PLANS */}

                                <Row className="g-4 mt-3">
                                    {plans.map((plan, index) => (
                                        <Col lg={3} md={6} key={index}>
                                            <Card className={`pricing-card ${(selectedPlan && selectedPlan.toLowerCase() === plan.name.toLowerCase()) && "selected-plan-card"}`}>
                                                {plan.popular && (
                                                    // <Badge
                                                    //     bg="danger"
                                                    //     className="popular-badge"
                                                    // >
                                                    //     Most Popular
                                                    // </Badge>
                                                    <div class="price-ribbon">
                                                        <span id="link-value2" class="ribbon-price" data-monthly="79" data-yearly="790">Most</span>
                                                        <small class="ribbon-period">Popular</small>
                                                    </div>
                                                )}
                                                <Card.Body>
                                                    <h5
                                                        className="plan-title"
                                                        style={{
                                                            color: plan.color
                                                        }}
                                                    >
                                                        {plan.name}
                                                    </h5>

                                                    <div className="price-box">
                                                        <h1>
                                                            {plan.price}
                                                        </h1>
                                                        <span>
                                                            /month
                                                        </span>
                                                    </div>

                                                    <div className="credits-text">
                                                        {plan.credits}
                                                    </div>

                                                    <Button
                                                        className="subscribe-btn"
                                                        style={{
                                                            background: getCredits?.current_plan && getCredits?.current_plan.toLowerCase() === plan.name.toLowerCase() ? plan.current_plan_button : plan.button_color,
                                                            borderColor: getCredits?.current_plan && getCredits?.current_plan.toLowerCase() === plan.name.toLowerCase() ? plan.current_plan_button : plan.button_color
                                                        }}
                                                        onClick={() => selectPlanFun(plan)}
                                                    >
                                                        {(getCredits?.current_plan && getCredits?.current_plan.toLowerCase() === plan.name.toLowerCase()) ? "Current Plan" : (selectedPlan && selectedPlan.toLowerCase()) === plan.name.toLowerCase() ? "Selected" : "Select Plan"}
                                                    </Button>

                                                    <div className="feature-list">
                                                        {plan.features.map((feature, i) => (
                                                            <div
                                                                className="feature-item"
                                                                key={i}
                                                            >
                                                                <CheckCircleFill
                                                                    className="check-icon"
                                                                />
                                                                <span>
                                                                    {feature}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>

                                <div className="credit-section">
                                    <h2 className="credit-heading">
                                        Add Extra Credits
                                    </h2>
                                    <p className="credit-subtitle">
                                        Need more leads? Purchase additional credits anytime.
                                    </p>
                                    <AddCreditsCard selectedPlanDetail={selectedPlanDetail} billingType={billingType}
                                        plan={selectPlanData} setSelectedAddCredits={setSelectedAddCredits} selectedAddCredits={selectedAddCredits} />
                                </div>

                                <div className="plan-summary-bar">

                                    <div className="summary-section">

                                        <span className="summary-label">
                                            Summary
                                        </span>

                                        <h3>
                                            {capitalizeFirstLetter(selectedPlan)} Plan
                                        </h3>

                                        {/* <button className="breakdown-btn">
                                            See price breakdown
                                        </button> */}

                                    </div>

                                    <div className="summary-divider"></div>

                                    <div className="summary-info">

                                        <div className="up-summary-item">
                                            <span>Plan Duration</span>
                                            <h4>{capitalizeFirstLetter(billingType)}</h4>
                                        </div>

                                        <div className="summary-divider vertical"></div>

                                        <div className="up-summary-item">
                                            <span>Plan Amount</span>
                                            <h4>${planAmnt}/{billingType === "yearly" ? "yr" : "mth"}</h4>
                                        </div>

                                        <div className="summary-divider vertical"></div>

                                        <div className="up-summary-item">
                                            <span>Additional Credits</span>
                                            <h4>${addAmnt}</h4>
                                        </div>

                                        <div className="summary-divider vertical"></div>

                                        <div className="up-summary-item">
                                            <span>Total Payable</span>
                                            <h4>${totalAmnt}</h4>
                                        </div>

                                    </div>

                                    <button className="upgrade-btn" onClick={upgadrePlan}>
                                        Upgrade
                                    </button>

                                </div>
                            </div>


                        </Container>
                    </div>
                </div>
                <Footer />
            </div>

            <Modal
                show={showPaymentSuccess}
                centered
                size="lg"
                backdrop="static"
                onHide={() => setShowPaymentSuccess(false)}
                className="payment-success-modal"
            >
                <Modal.Body className="p-0">

                    <div className="payment-success-header">

                        <div className="payment-icon">
                            <i className="fa fa-check"></i>
                        </div>

                        <h2>Payment Successful</h2>

                        <p>
                            Thank you for your purchase!
                        </p>

                    </div>

                    <div className="p-3">

                        <div className="payment-summary-card">

                            <h3 className="summary-heading">
                                Order Summary
                            </h3>

                            <div className="summary-grid" style={{ width: "100%" }}>

                                {/* Left Side */}

                                <div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Plan</span>
                                        <strong>{paymentInfo?.plan}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Billing</span>
                                        <strong>{paymentInfo?.billingType}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Credits</span>
                                        <strong>{paymentInfo?.credits}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Amount Paid</span>
                                        <strong className="text-primary">
                                            {paymentInfo?.currency} {paymentInfo?.amount}
                                        </strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Status</span>

                                        <span className="badge bg-success">
                                            {paymentInfo?.status}
                                        </span>

                                    </div>

                                </div>

                                {/* Right Side */}

                                <div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Customer</span>
                                        <strong>{paymentInfo?.customerName}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Email</span>
                                        <strong>{paymentInfo?.customerEmail}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">SBN ID</span>
                                        <strong>{paymentInfo?.sbnId}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">PayPal Email</span>
                                        <strong>{paymentInfo?.payerEmail}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Payer ID</span>
                                        <strong>{paymentInfo?.payerId}</strong>
                                    </div>

                                </div>

                            </div>

                            <hr />

                            <div className="summary-grid">

                                <div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Order ID</span>
                                        <strong>{paymentInfo?.orderId}</strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Transaction ID</span>
                                        <strong>{paymentInfo?.captureId}</strong>
                                    </div>

                                </div>

                                <div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Payment Date</span>
                                        <strong>
                                            {paymentInfo?.paymentDate &&
                                                moment(new Date(paymentInfo.paymentDate).toLocaleDateString()).format("DD MMM, YYYY")}
                                        </strong>
                                    </div>

                                    <div className="up-summary-item">
                                        <span className="m-0">Plan Ends</span>
                                        <strong className="text-primary">
                                            {paymentInfo?.planEndDate &&
                                                moment(new Date(paymentInfo.planEndDate).toLocaleDateString()).format("DD MMM, YYYY")}
                                        </strong>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="d-grid gap-2 mt-4">

                            <Button
                                className="upgrade-btn"
                                // variant="success"
                                onClick={() => {

                                    setShowPaymentSuccess(false);

                                    //navigate("/dashboard")

                                }}
                            >
                                Continue
                            </Button>

                        </div>

                    </div>

                </Modal.Body>

            </Modal>
        </PayPalScriptProvider>
    );
}

export default UpgradePlan;